import React from 'react';
import PropTypes from 'prop-types';
import Footer from './common/Footer';
import DesktopWindow from './desktop/DesktopWindow';
import ThankyouContent from './common/ThankyouContent';
import { Link, Page, Icon } from 'framework7-react';
import II18 from './translate/II18';
import { PATHS } from './helpers/navigator';

class ThankyouDesktop extends React.Component {
  render() {
    const { brandingDetails } = this.props;

    return (
      <Page>
        <DesktopWindow
          caseName={this.props.caseName}
          companyName={this.props.companyName}
          companyEmail={this.props.companyEmail}
          companyLogo={this.props.companyLogo}
        >
          <>
            <Link href={'/' + PATHS.LIST}>
              <Icon material="arrow_back" /> {II18.get('title_back')}
            </Link>
            <ThankyouContent
              recipientRequestId={this.props.recipientRequestId}
              companyName={this.props.companyName}
            />
          </>
        </DesktopWindow>

        <Footer
          customFooterText={brandingDetails.customFooterText}
          hideLogo={brandingDetails.hidePaperflyLogo}
        />
      </Page>
    );
  }
}

ThankyouDesktop.propTypes = {
  recipientRequestId: PropTypes.string,
  caseName: PropTypes.string,
  brandingDetails: PropTypes.object,
  companyLogo: PropTypes.string,
  companyName: PropTypes.string,
  companyEmail: PropTypes.string
};
export default ThankyouDesktop;
